import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

// const swiper = new Swiper(...);

if (document.querySelector(".roomsslider")) {
  const roomsSwiper = new Swiper(".roomsslider", {
    // Optional parameters
    // loop: true,
    slidesPerView: "auto",
    centeredSlides: true,
    initialSlide: 1,
    // Navigation arrows
    navigation: {
      nextEl: ".slider__next",
      prevEl: ".slider__prev",
    },
    on: {
      click() {
        roomsSwiper.slideTo(this.clickedIndex);
      },
    },
  });

  if (roomsSwiper?.el) {
    roomsSwiper.el
      .querySelector(".slider__next")
      ?.addEventListener("click", () => {
        roomsSwiper.slideNext();
      });
    roomsSwiper.el
      .querySelector(".slider__prev")
      ?.addEventListener("click", () => {
        roomsSwiper.slidePrev();
      });
  }
}
